import React, { useEffect } from "react";
import "../styles/DosDonts.css";

const DosDonts = () => {

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("show");
                    }
                });
            },
            { threshold: 0.15 }
        );

        const hiddenElements = document.querySelectorAll(".hidden");
        hiddenElements.forEach((el) => observer.observe(el));

        return () => observer.disconnect();
    }, []);

    return (
        <main className="dos-container">

            {/* HERO */}
            <section className="dos-hero hidden">
                <h1>Do's & Dont's</h1>
                <p>Stay Safe. Stay Secure. Bank Smart.</p>
            </section>

            {/* INTRO */}
            <section className="dos-intro hidden">
                <h2>Important Safety Guidelines for Customers</h2>
                <p>
                    Your security is our priority. Please follow these essential
                    guidelines to protect your card, ATM transactions, and online
                    banking activities.
                </p>
            </section>

            {/* IMAGE SECTION 1 */}
            <section className="dos-image-section hidden">
                <img
                    src="https://images.unsplash.com/photo-1563986768609-322da13575f3?auto=format&fit=crop&w=1600&q=80"
                    alt="Online Banking Security"
                />
                <div className="image-overlay">
                    <h2>Stay Alert Against Digital Fraud</h2>
                </div>
            </section>

            {/* DO SECTION */}
            <section className="dos-section hidden">
                <h2 className="section-title">✅ Do's</h2>

                <div className="card-grid">

                    <div className="dos-card">
                        <h3>🏧 Use Secure ATMs</h3>
                        <ul>
                            <li>Use ATMs located in well-lit, secure areas.</li>
                            <li>Prefer ATMs at bank branches or reputable institutions.</li>
                            <li>Check the ATM for any suspicious devices before using it.</li>
                        </ul>
                    </div>

                    <div className="dos-card">
                        <h3>🔐 Shield Your PIN</h3>
                        <ul>
                            <li>Always cover the keypad with your hand.</li>
                            <li>Memorize your PIN; don’t write it down.</li>
                            <li>Avoid easily guessable PINs like your birth date.</li>
                        </ul>
                    </div>

                    <div className="dos-card">
                        <h3>💳 Protect Your Card</h3>
                        <ul>
                            <li>Temporarily disable your card using Card Safe App.</li>
                            <li>Set minimum transaction limits.</li>
                            <li>Don’t share card, PIN, or transaction details.</li>
                        </ul>
                    </div>

                    <div className="dos-card">
                        <h3>📊 Monitor Your Account</h3>
                        <ul>
                            <li>Check bank statements regularly.</li>
                            <li>Sign up for transaction alerts.</li>
                        </ul>
                    </div>

                    <div className="dos-card">
                        <h3>💳 Set Card Transaction Limit</h3>
                        <ul>
                            <li>Set limits for ATM, ECOM and POS transactions.</li>
                            <li>Enable card only when required and disable immediately after use.</li>
                        </ul>
                    </div>

                    <div className="dos-card">
                        <h3>🌐 Use Secure Websites</h3>
                        <ul>
                            <li>Shop on https:// websites with padlock icon.</li>
                            <li>Look for trust seals and reviews.</li>
                            <li>Use payment methods with buyer protection.</li>
                        </ul>
                    </div>

                    <div className="dos-card">
                        <h3>🚨 Report Lost or Stolen Cards</h3>
                        <ul>
                            <li>Report immediately to prevent misuse.</li>
                            <li>Save bank customer care number for quick access.</li>
                        </ul>
                    </div>

                </div>
            </section>

            {/* IMAGE SECTION 2 */}
            <section className="dos-image-section hidden">
                <img
                    src="https://images.unsplash.com/photo-1556742031-c6961e8560b0"
                    alt="Secure Banking"
                />
                <div className="image-overlay">
                    <h2>Your Awareness is Your Best Protection</h2>
                </div>
            </section>

            {/* DON'T SECTION */}
            <section className="dont-section hidden">
                <h2 className="section-title red">❌ Don'ts</h2>

                <div className="card-grid">

                    <div className="dont-card">
                        <h3>🚫 Never Share PIN</h3>
                        <ul>
                            <li>Never share your PIN with anyone.</li>
                            <li>Do not write down your PIN.</li>
                        </ul>
                    </div>

                    <div className="dont-card">
                        <h3>🚫 Avoid Suspicious ATMs</h3>
                        <ul>
                            <li>Avoid damaged or isolated ATMs.</li>
                            <li>Don’t use compromised machines.</li>
                        </ul>
                    </div>

                    <div className="dont-card">
                        <h3>🚫 Don’t Let Strangers Assist</h3>
                        <ul>
                            <li>Politely decline help from strangers.</li>
                        </ul>
                    </div>

                    <div className="dont-card">
                        <h3>🚫 Don’t Click Suspicious Links</h3>
                        <ul>
                            <li>Beware of phishing emails and popups.</li>
                            <li>Never share CVV or OTP.</li>
                        </ul>
                    </div>

                    <div className="dont-card">
                        <h3>🚫 Don’t Share Card Details Over Phone</h3>
                        <ul>
                            <li>Never provide card details over phone calls.</li>
                        </ul>
                    </div>

                </div>
            </section>

            {/* WARNING */}
            <section className="security-warning hidden">
                <h2>⚠ Important Reminder</h2>
                <p>
                    Sahyadri Sahakari Bank will NEVER ask for your PIN, CVV, OTP, or
                    complete card details over phone, email, or SMS.
                </p>
            </section>

        </main>
    );
};

export default DosDonts;